// extracted by mini-css-extract-plugin
module.exports = {"group":"group-c01r0","item":"item-h2RpY","label":"label-182cb","value":"value-SRm0P"};